'use strict';

const crypto = require('crypto');
const node = require('when/node');
const path = require('path');
const when = require('when');

const fs = node.liftAll(require('fs'));

async function loadChecksums(checksumsFile) {
  const checksums = {};
  const contents = await fs.readFile(checksumsFile);
  const lineRegexp = /^([0-9a-f]{32})  (\S+)$/gm;
  let match;
  while ((match = lineRegexp.exec(contents))) {
    const checksum = match[1];
    const file = match[2];
    checksums[file] = checksum;
  }
  return checksums;
}

module.exports = async function process(rootDirectory, cacheDirectory, cacheUrl) {
  try {
    await fs.stat(cacheDirectory);
  } catch (err) {
    if (err.code === 'ENOENT') {
      await fs.mkdir(cacheDirectory, 0o755);
    } else {
      throw err;
    }
  }

  const checksumsFile = path.join(cacheDirectory, 'checksums.txt');
  let checksumsModified = new Date(0);
  let checksums = {};
  try {
    const stat = await fs.stat(checksumsFile);
    checksumsModified = stat.mtime;
    checksums = await loadChecksums(checksumsFile);
  } catch (err) {
    if (err.code !== 'ENOENT') {
      throw err;
    }
  }

  const files = [];
  const cssFiles = [];
  async function walk(dir) {
    const entries = await when.map(fs.readdir(dir), entry => path.join(dir, entry));
    const stats = await when.map(entries, entry => fs.stat(entry));
    const numEntries = entries.length;
    for (let i = 0; i < numEntries; i++) {
      const stat = stats[i];
      if (stat.isDirectory()) {
        dir = entries[i];
        if (dir !== cacheDirectory) {
          await walk(dir);
        }
      } else {
        const file = entries[i];
        if (!path.basename(file).startsWith('.')) {
          if (path.extname(file) === '.css') {
            cssFiles.push(file);
          } else {
            files.push(file);
          }
        }
      }
    }
  }
  await walk(rootDirectory);

  async function processFile(file) {
    const contents = await fs.readFile(file);
    const relativeFile = file.replace(rootDirectory, '').slice(1);
    checksums[relativeFile] = crypto.createHash('md5').update(contents).digest('hex');
    try {
      await fs.link(file, path.join(cacheDirectory, checksums[relativeFile] + path.extname(file)));
    } catch (err) {
      if (err.code !== 'EEXIST') {
        throw err;
      }
    }
  }
  await when.map(files, processFile);

  async function processCssFile(file) {
    let contents = await fs.readFile(file, 'utf8');
    contents = contents.replace(/url\(\s*(["']?)\/([^)]*)\1\s*\)/g, function (match, q, relativeFile) {
      const checksum = checksums[relativeFile];
      return checksum ? `url(${q}${cacheUrl}/${checksum}/${relativeFile}${q})` : match;
    });
    const relativeFile = file.replace(rootDirectory, '').slice(1);
    checksums[relativeFile] = crypto.createHash('md5').update(contents).digest('hex');
    await fs.writeFile(path.join(cacheDirectory, checksums[relativeFile] + '.css'), contents);
  }
  await when.map(cssFiles, processCssFile);

  return checksums;
};
